import "./Loading.css";

import type { SpinProps } from "antd";
import { Spin } from "antd";
import React from "react";

interface LoadingProps extends Omit<SpinProps, "spinning"> {
  message?: string;
  fullScreen?: boolean;
}

export const Loading = ({
  message = "Loading...",
  fullScreen = true,
  size = "large",
  ...rest
}: LoadingProps) => {
  const containerClass = fullScreen
    ? "loading-container loading-fullscreen"
    : "loading-container";

  return (
    <div className={containerClass}>
      <Spin size={size} spinning={true} {...rest} />
      {message && <div className="loading-message">{message}</div>}
    </div>
  );
};
